export const idlFactory = ({ IDL }) => {
  const TransactionType = IDL.Variant({
    'DeviceDiscovered' : IDL.Null,
    'DeviceUpdated' : IDL.Null,
    'ConfigurationChange' : IDL.Null,
    'DeviceRemoved' : IDL.Null,
    'SecurityEvent' : IDL.Null,
    'CredentialUsed' : IDL.Null,
  });
  const TransactionId = IDL.Text;
  const Result_1 = IDL.Variant({ 'ok' : TransactionId, 'err' : IDL.Text });
  const BlockId = IDL.Text;
  const Result = IDL.Variant({ 'ok' : BlockId, 'err' : IDL.Text });
  const AuditRecord = IDL.Record({
    'transaction_id' : TransactionId,
    'block_id' : BlockId,
    'transaction_type' : TransactionType,
    'data_summary' : IDL.Text,
    'device_id' : IDL.Opt(IDL.Text),
    'user_id' : IDL.Opt(IDL.Text),
    'timestamp' : IDL.Int,
  });
  const Hash = IDL.Text;
  const Transaction = IDL.Record({
    'id' : TransactionId,
    'transaction_type' : TransactionType,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'data' : IDL.Text,
    'hash' : Hash,
    'device_id' : IDL.Opt(IDL.Text),
    'user_id' : IDL.Opt(IDL.Text),
    'timestamp' : IDL.Int,
  });
  const Block = IDL.Record({
    'id' : BlockId,
    'hash' : Hash,
    'merkle_root' : Hash,
    'previous_hash' : Hash,
    'nonce' : IDL.Nat,
    'timestamp' : IDL.Int,
    'index' : IDL.Nat,
    'transactions' : IDL.Vec(Transaction),
  });
  return IDL.Service({
    'add_transaction' : IDL.Func(
        [
          TransactionType,
          IDL.Text,
          IDL.Opt(IDL.Text),
          IDL.Opt(IDL.Text),
          IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
        ],
        [Result_1],
        [],
      ),
    'create_block' : IDL.Func([IDL.Vec(TransactionId)], [Result], []),
    'get_audit_trail' : IDL.Func(
        [IDL.Opt(IDL.Text), IDL.Opt(TransactionType), IDL.Nat],
        [IDL.Vec(AuditRecord)],
        ['query'],
      ),
    'get_block' : IDL.Func([BlockId], [IDL.Opt(Block)], ['query']),
    'get_blockchain_stats' : IDL.Func(
        [],
        [
          IDL.Record({
            'latest_block_timestamp' : IDL.Opt(IDL.Int),
            'total_transactions' : IDL.Nat,
            'chain_integrity' : IDL.Bool,
            'total_blocks' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'get_latest_block' : IDL.Func([], [IDL.Opt(Block)], ['query']),
    'get_transaction' : IDL.Func(
        [TransactionId],
        [IDL.Opt(Transaction)],
        ['query'],
      ),
    'list_blocks' : IDL.Func([IDL.Nat], [IDL.Vec(Block)], ['query']),
    'list_transactions' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(Transaction)],
        ['query'],
      ),
    'verify_blockchain' : IDL.Func(
        [],
        [
          IDL.Record({
            'invalid_blocks' : IDL.Vec(BlockId),
            'is_valid' : IDL.Bool,
            'total_blocks' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
